export const CONSTANTS = {
  resendOTPTimer: 120,
  VKYCStatusapitimeOut: 600,
  BLOCKUSERTIMER: 120,
  // BLOCKUSERTIMER: 50,

  // start intervals timmer
  panFormInterval: {
    TIMERINITIAL: 0,
    INTERVALTIMER: 5000,
    MAXTIMER: 300,
  },
  bankStatementInterval: {
    TIMERINITIAL: 0,
    INTERVALTIMER: 20000,
    MAXTIMER: 600000,
  },
  otpInterval: {
    INTERVALTIMER: 1000,
  },
  otpPayInterval: {
    INTERVALTIMER: 1000,
  },
  pendingEnach_DigioInterval: {
    TIMERINITIAL: 0,
    INTERVALTIMER: 4000,
    MAXTIMER: 1200000,
  },
  pendingKYCInterval: {
    INTERVALTIMER_0: 1000,
    TIMERINITIAL_1: 0,
    INTERVALTIMER_1: 30000,
    MAXTIMER_1: 600000,
  },
  // end intervals timmer
  brandName: {
    smallCase: "Tyger",
  },
};
